import { Injectable } from '@angular/core';
import { FirestoreService } from './firestore/firestore.service';
import { Globals } from '../globals';
import { Observable } from 'rxjs';

export interface DefectId{
  id?: string;
  AQL: string;
  active: boolean;
  createdAt: Date;
  customerId: string;
  description: string;
  folio: string;
  group: string;
  updatedAt: Date;
}

@Injectable()
export class DefectService {

  collection: string = '';
  customerCollection: string = '';

  constructor(
    private afh: FirestoreService
  ) {
    this.collection = Globals.DEFECT_COLLECTION;
    this.customerCollection = Globals.CUSTOMER_SUPPLIER_COLLECTION;

    console.log('defect service up');
  }

  getDefect(id: string){
    return this.afh.docWithIds$(`${this.collection}/${id}`).map(({customerId, ...document}: DefectId) => Observable.combineLatest(
      customerId ? this.afh.docWithIds$(`${this.customerCollection}/${customerId}`) : this.afh.docWithIds$(`${this.collection}/${document.id}`),
      (customer) => ({customer})
    ).map(({customer}) => ({customerObj: customerId ? customer : undefined, ...document}) ) ).mergeMap(d => Observable.combineLatest(d));
  }

  getDefects({customerId='', onEmpty=<any>undefined}={}){
    let col = customerId ?
      this.afh.colWithIds$(`${this.collection}`, ref => ref.where('active', '==', true).where('customerId', '==', customerId) ) :
      this.afh.colWithIds$(`${this.collection}`, ref => ref.where('active', '==', true) );
    return col.map(documents => {
      if(!documents.length && onEmpty) onEmpty();
      return documents.map(({customerId, ...document}: DefectId) => Observable.combineLatest(
        customerId ? this.afh.docWithIds$(`${this.customerCollection}/${customerId}`) : this.afh.docWithIds$(`${this.collection}/${document.id}`),
        (customer) => ({customer})
      ).map(({customer}) => ({customerObj: customerId ? customer : undefined, ...document}) ) )
    }).mergeMap(d => Observable.combineLatest(d));
  }

  addDefect(defect: DefectId){
    return this.afh.add(`${this.collection}`, defect);
  }

  updateDefect(id: string, defect: DefectId){
    this.afh.update(`${this.collection}/${id}`, defect);
  }

  deleteDefect(id: string){
    this.afh.delete(`${this.collection}/${id}`);
  }
}
